<template>
  <section class="section-sticky" :class="{ open }">
    <div data-wrapper>
      <div :data-sticky="active ? 'true' : 'false'" class="container" data-aos="fade-up">
        <span class="bg-overlay" :class="bg"></span>
        <div class="section-sticky-content" :class="bg">
          <div ref="wrapper" class="section-sticky-content-wrapper" :style="{'--height': frHeight}">
            <slot></slot>
          </div>
          <button class="sticky-toggle" ref="button" @click="onToggle">
            {{open ? 'Show less' : 'Show more'}} <i v-icon:chevron-down></i>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "SectionSticky",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    bg: {
      type: String,
      default: "has-background-white",
    },
  },
  data() {
    return {
      height: "auto",
      open: false,
      height: 0
    };
  },
  computed:{
    frHeight(){
      return  Math.round((45 / this.height) * 100) / 100 + "fr";
    }
  },
  mounted() {
    const $nav = this.$el.querySelector(".nav-menu");
    if($nav){
      this.accordionInit($nav);
      window.addEventListener("resize", () => {
        this.accordionInit($nav);
      })
    }

    if (this.active) this.$store.commit("PUSH_STICKY", this.$el);
  },
  methods: {
    accordionInit($nav) {
      this.height = $nav.scrollHeight;      
    },
    onToggle() {
      this.open = !this.open
    },
    girdTemplate($md) {
      const $ul = this.$el.querySelector("ul.nav-menu-wrapper");
      const $li = $ul.querySelectorAll("li");

      if ($li.length <= 2) {
        $ul.style.gridTemplateColumns = `repeat(${$md.matches ? 2 : 1}, 1fr)`;
        $ul.style.gridTemplateRows = $md.matches ? `repeat(1, 1fr)` : "";
      } else if ($li.length == 3) {
        $ul.style.gridTemplateColumns = `repeat(${$md.matches ? 3 : 1}, 1fr)`;
        $ul.style.gridTemplateRows = $md.matches ? `repeat(1, 1fr)` : "";
      } else if ($li.length > 3 && $li.length < 5) {
        $ul.style.gridTemplateColumns = `repeat(${$md.matches ? 2 : 1}, 1fr)`;
        $ul.style.gridTemplateRows = $md.matches ? `repeat(2, 1fr)` : "";
      } else {
        $ul.style.gridTemplateColumns = `repeat(${$md.matches ? 3 : 1}, 1fr)`;
        $ul.style.gridTemplateRows = $md.matches
          ? `repeat(${Math.ceil($li.length / 3)}, 1fr)`
          : "";
      }
    },
  },
};
</script>
